<template>
  <el-card>
    <el-row>
      <el-form :model="form" v-bind="formProps.form" :rules="{}">
        <el-form-item align="center" :label="$t('withdrawBank.label.createTime')">
          <el-date-picker
            v-model="createTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            :clearable="false"
          />
        </el-form-item>
        <el-form-item :label="$t('device.withdrawal.payId')" prop="phone">
          <el-input v-model="form.phone" />
        </el-form-item>
        <el-form-item :label="$t('device.payOrder')" prop="transId">
          <el-input v-model="form.transId" />
        </el-form-item>
        <el-form-item>
          <el-form-item :label="$t('device.withdrawal.serial')" prop="serial">
            <el-input v-model="form.serial" />
          </el-form-item>
          <el-form-item :label="$t('device.withdrawal.status')" prop="status">
            <el-select v-model="form.status">
              <el-option
                v-for="item in callbackStatusOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-button
            v-if="permission.indexOf('devices:zalo:withdraw:excel') > -1"
            size="mini"
            type="primary"
            @click="handleExport()"
            >{{ $t('btns.export') }}</el-button
          >
          <el-button size="mini" type="warning" @click="handleEmpty()">{{
            $t('btns.empty')
          }}</el-button>
          <el-button size="mini" type="primary" @click="handleSearch()">{{
            $t('btns.search')
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <!-- <el-row>
      <div class="header-table" v-if="totalData">
        <ul class="list-table">
          <li class="li-table">
            <em class="label">
              <span>
                {{ $t('device.withdrawal.orderNumberTotal') }}
              </span>
              <span>：</span>
            </em>
            <span class="value">
              {{ totalData.successAmount | toThousands }}
            </span>
          </li>
          <li class="li-table">
            <em class="label">
              <span>
                {{ $t('device.withdrawal.realAmount') }}
              </span>
              <span>：</span>
            </em>
            <span class="value">
              {{ totalData.realAmount | toThousands }}
            </span>
          </li>
          <li class="li-table">
            <em class="label">
              <span>
                {{ $t('device.withdrawal.totalfee') }}
              </span>
              <span>：</span>
            </em>
            <span class="value">
              {{ totalData.fee | toThousands }}
            </span>
          </li>
        </ul>
        <el-button size="mini" type="warning">{{
          $t('device.withdrawal.statistics')
        }}</el-button>
      </div>
    </el-row> -->
    <el-row>
      <el-table
        :data="tableList"
        stripe
        class="table"
        ref="table"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ textAlign: 'center' }"
      >
        <el-table-column prop="phone" align="center" :label="$t('device.withdrawal.phone')" />
        <el-table-column prop="serial" align="center" :label="$t('device.withdrawal.serial')" />
        <el-table-column prop="transId" align="center" :label="$t('device.payOrder')" />

        <el-table-column
          prop="receiverNumber"
          align="center"
          :label="$t('device.withdrawal.receiverNumber')"
        />
        <el-table-column
          prop="senderNumber"
          align="center"
          :label="$t('device.withdrawal.senderNumber')"
        />
        <el-table-column prop="fee" align="center" :label="$t('device.withdrawal.amount')">
          <template slot-scope="{ row }">
            {{ row.amount | toThousands }}
          </template>
        </el-table-column>
        <el-table-column prop="fee" align="center" :label="$t('device.withdrawal.fee')">
          <template slot-scope="{ row }">
            {{ row.fee | toThousands }}
          </template>
        </el-table-column>
        <el-table-column prop="total" align="center" :label="$t('device.withdrawal.total')">
          <template slot-scope="{ row }">
            {{ row.total | toThousands }}
          </template>
        </el-table-column>
        <el-table-column prop="type" align="center" :label="$t('device.withdrawal.momo.type')">
          <template slot-scope="{ row }">
            <!-- <span v-if="row.type === 1"> 向外部账户转账 </span>
            <span v-if="row.type === 2"> 向关联账户转账 </span>
            <span v-if="row.type === 3"> 内部账户转账 </span> -->
            {{ $t(`device.withdrawal.transferTypes[${row.type - 1}]`) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" align="center" :label="$t('device.withdrawal.status')">
          <template slot-scope="{ row }">
            <span v-if="row.status == '1'" style="color: green"> {{ $t('status.success') }} </span>
            <span v-if="row.status != '1'" style="color: red"> {{ $t('status.error') }} </span>
          </template>
        </el-table-column>
        <el-table-column prop="message" align="center" :label="$t('device.withdrawal.message')" />
        <el-table-column prop="error" align="center" :label="$t('device.withdrawal.error')" />
        <el-table-column prop="creator" align="center" :label="$t('device.withdrawal.creator')" />

        <el-table-column prop="created" align="center" :label="$t('device.withdrawal.created')" />
      </el-table>
    </el-row>

    <v-pagination v-model="pagination" :total="tableData.rows" @update="getTableData" />

    <v-editor
      ref="editor"
      :statusData="statusData"
      :serviceTypes="serviceTypes"
      :rules="formProps.form.rules"
      :channelTypeList="channelTypeList"
      :channelTypeData="channelTypeData"
      @doConfAdd="doConfAdd"
      @doConfUpdate="doConfUpdate"
    />
  </el-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { debounce } from 'lodash';
import device_API from '@/api/device';
import vEditor from './editor';
export default {
  components: {
    vEditor
  },
  data() {
    return {
      form: {
        senderAccount: '',
        systemOrderNo: '',
        status: '',
        receiverNumber: ''
      },
      createTime: null,
      pagination: {
        no: 1,
        size: this.$defaultPaginationSize
      },
      channelTypeData: {},
      tableData: {}
    };
  },
  computed: {
    ...mapGetters(['permission']),
    callbackStatusOption() {
      return [
        {
          value: -1,
          label: this.$t('status.error')
        },
        {
          value: 1,
          label: this.$t('status.success')
        }
      ];
    },
    tableList() {
      return this.tableData.list || [];
    },
    totalData() {
      return this.tableData.summary || {};
    },
    channelTypeList() {
      return Object.keys(this.channelTypeData) || [];
    },
    channelCodeList() {
      if (Array.isArray(this.channelTypeData[this.form.channelType])) {
        return this.channelTypeData[this.form.channelType].length > 0
          ? this.channelTypeData[this.form.channelType]
          : '';
      } else {
        return '';
      }
    },
    statusData() {
      return [
        {
          label: this.$t('status.success2'),
          type: 'success',
          value: 1
        },
        {
          label: this.$t('status.error2'),
          type: 'error',
          value: 0
        }
      ];
    }
  },
  created() {
    function getdate() {
      var date = new Date();
      var seperator1 = '-';
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = '0' + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    }
    this.createTime = [getdate() + ' 00:00:00', getdate() + ' 23:59:59'];
    this.init();
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    init() {
      this.handleSearch = debounce(this._handleSearch, 300);

      /* ----------------------------- element -props ----------------------------- */
      this.formProps = {
        form: {
          ref: 'form',
          'label-width': 'auto',
          inline: true,
          size: 'small',
          rules: {
            channelCode: [
              {
                required: true,
                message: this.$t('channel.rules.channelCode'),
                trigger: 'change'
              }
            ],
            channelType: [
              {
                required: true,
                message: this.$t('channel.rules.channelType'),
                trigger: 'change'
              }
            ]
          }
        }
      };
      this.serviceTypes = ['api', 'auto'];
    },

    /* ---------------------------------- 格式化数据 --------------------------------- */
    formatParams() {
      return {
        ...Object.keys(this.form).reduce((acc, key) => {
          if (this.form[key] === 0 || this.form[key]) {
            acc[key] = this.form[key];
          }
          if (key === 'channelCode') {
            acc.channelCode = '';
          }
          return acc;
        }, {})
        // ...this.pagination
      };
    },
    /* --------------------------------- 获取分页数据 --------------------------------- */
    async getTableData() {
      let param = this.form;
      if (this.createTime) {
        let [beginTime, endTime] = this.createTime;
        param.beginDate = beginTime;
        param.endDate = endTime;
      }

      const { data } = await device_API.viettel_draw_list({
        query: this.form,
        no: this.pagination.no,
        size: this.pagination.size
      });
      if (data && data.code == 200) {
        this.tableData = data.data;
      }
    },
    async handleExport() {
      const { data } = await device_API.doExport_draw(this.formatParams(), 'viettel');
      if (data) {
        const BLOB = data;
        const fileReader = new FileReader();
        fileReader.readAsDataURL(BLOB);
        fileReader.onload = (event) => {
          // 处理load事件。该事件在读取操作完成时触发
          // 新建个下载的a标签，完成后移除。
          let a = document.createElement('a');
          a.download = `Merchant-WithdrawList${Number(new Date())}.xlsx`;
          a.href = event.target.result;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };
      } else {
        this.$message.error(this.$t('status.error'));
      }
    },

    formatParams() {
      const [createTimeStart, createTimeEnd] = this.createTime;
      return {
        ...Object.keys(this.form).reduce((acc, key) => {
          acc[key] = this.form[key];
          return acc;
        }, {}),
        beginTime: createTimeStart,
        endTime: createTimeEnd
      };
    },

    async doConfAdd(formUpdate, cb) {
      const params = {
        ...formUpdate
      };
      const { data } = await device_API.bank_draw_create(params);
      if (data.code == 200) {
        cb();
      } else {
        this.$message.error(data.msg);
      }
      this.getTableData();
      this.getTableTotal();
    },

    async doConfUpdate(formUpdate, cb) {
      const params = {
        ...formUpdate
      };
      const { data } = await device_API.bank_draw_confirm(params);
      if (data.code == 200) {
        cb();
      } else {
        this.$message.error(data.msg);
      }
      this.getTableData();
    },
    /* --------------------------------- 事件驱动函数 --------------------------------- */
    handleEmpty() {
      this.form = {
        senderAccount: '',
        systemOrderNo: '',
        status: '',
        receiverNumber: ''
      };
    },
    handleEditor(row) {
      this.$refs.editor.init(row);
    },
 
    _handleSearch() {
      this.$refs.form.validate(async (valid) => valid && this.getTableData());
    }
  }
};
</script>

<style scoped>
.header-table {
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.2);
  padding-right: 40px;
}

.header-table .list-table {
  display: flex;
  list-style: none;
}

.header-table .list-table li {
  display: flex;
  list-style: none;
}

.header-table .list-table li .label {
  font-style: normal;
}

.header-table .list-table li .value {
  display: flex;
  list-style: none;
}

.header-table .list-table li:nth-child(n + 2) {
  margin-left: 30px;
}

.header-table .btn-table {
  margin-left: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/device/viettelwithdrawak.vue